module.exports = __webpack_public_path__ + "img/squishies.2fc59f93.png";